import Vue from 'vue'
import Router from 'vue-router'

import Index from '@/components/index/index'

import OrderStates from '@/components/index/OrderStates' //订单状态
import Orderlist from '@/components/index/Orderlist' //订单状态
import orderlislist from '@/components/index/orderlislist' //订单状态

import Receipt from '@/components/index/Receipt' //订单状态
import Receivables from '@/components/index/Receivables'//收款
import MyUser from "@/components/index/MyUser" //我的 

import addMerchant from '@/components/Receivables/adddetail'//添加商户

import Googlecode from '@/components/banggoogle/Googlecode'//绑定谷歌


import PhoneLogin from '@/components/login/phone/phoneLogin'//临时登录
import Login from '@/components/login/phone/Login'//手机登录

import Recharge from '@/components/my/Recharge'//充值

import CashWithdrawal from '@/components/my/CashWithdrawal'//提现

import security from '@/components/my/security'//账户安全

import changeCode from '@/components/my/changeCode'//修改密码或者谷歌验证码

import Capital from '@/components/my/Capital'// 资金流水

import supplement from '@/components/my/supplement'//流水补充

import supmetdetail from '@/components/my/supmetdetail'//流水补充详情

import Frenchhistory from '@/components/my/Frenchhistory'//流水补充详情

import Frenchhistorydetail from '@/components/my/Frenchhistorydetail'//流水补充详情


import cropImage from '@/components/my/cropImage'//

import orderdetail from '@/components/order/orderdetail'// 订单详情

import Cashaudit from '@/components/my/Cashaudit'// 订单详情

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect:'/index',  // /systemError 维护   /index 正常
    },
    {
      path:'/index',
      component:Index,
      children:[
          {
            path: '',
            redirect: '/Orderlist'
          }
          ,{
            path:'/Orderlist',
            name: 'Orderlist',
            component: Orderlist,
            meta:{title: '订单列表'}
          } ,
          {
            path:'/orderlislist',
            name: 'orderlislist',
            component: orderlislist,
            meta:{title: '订单历史'}
          }
          
          ,{
            path:'/OrderStates',
            name: 'OrderStates',
            component: OrderStates,
            meta:{title: '订单状态'}
          } ,{
            path:'/Receipt',
            name: 'Receipt',
            component: Receipt,
            meta:{title: '收款'}
          }
          ,{
            path:'/Receivables',
            name: 'Receivables',
            component: Receivables,
            meta:{title: '收款账户'}
          }
          ,{
            path:'/MyUser',
            name: 'MyUser',
            component: MyUser,
            meta:{title: '我的'}
          }
         
          
      ]
    },
    {
      path: '/phonelogin',
      name: 'phonelogin',
      component: PhoneLogin,
      meta:{title: '手机登录'}
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login,
      meta:{title: '手机登录'}
    },
      {
        path: '/addMerchant',
        name: 'addMerchant',
        component: addMerchant,
        meta:{title: '添加账户'}
      },
      {
        path: '/Googlecode',
        name: 'Googlecode',
        component: Googlecode,
        meta:{title: '绑定谷歌'}
      },
      {
        path: '/Recharge',
        name: 'Recharge',
        component: Recharge,
        meta:{title: '充值'}
      },
      {
        path: '/CashWithdrawal',
        name: 'CashWithdrawal',
        component: CashWithdrawal,
        meta:{title: '提现'}
      },
      {
        path: '/Cashaudit',
        name: 'Cashaudit',
        component: Cashaudit,
        meta:{title: '提现'}
        
      }
      ,{
        path: '/security',
        name: 'security',
        component: security,
        meta:{title: '账户安全'}
      },{
        path: '/changeCode',
        name: 'changeCode',
        component: changeCode,
        meta:{title: '账户安全'}
      },{
        path: '/Capital',
        name: 'Capital',
        component: Capital,
        meta:{title: '资金流水'}
      },{
        path: '/supplement',
        name: 'supplement',
        component: supplement,
        meta:{title: '流水明细补充'}
      },{
        path: '/supmetdetail',
        name: 'supmetdetail',
        component: supmetdetail,
        meta:{title: '补充'}
      }
      ,{
        path: '/Frenchhistory',
        name: 'Frenchhistory',
        component: Frenchhistory,
        meta:{title: '法币补充历史'}
      }
      ,{
        path: '/Frenchhistorydetail',
        name: 'Frenchhistorydetail',
        component: Frenchhistorydetail,
        meta:{title: '法币补充'}
      }
      ,{
        path: '/cropImage',
        name: 'cropImage',
        component: cropImage,
        meta:{title: '头像剪切'}
      }
      ,{
        path: '/orderdetail',
        name: 'orderdetail',
        component: orderdetail,
        meta:{title: '订单详情'}
      }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js